<script>
import Chart from 'chart.js'
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
Chart.defaults.global.defaultFontColor = '#2B4162';
Chart.defaults.global.defaultFontFamily = '"Gotham", sans-serif';
Chart.defaults.global.defaultFontSize = 10;
Chart.defaults.global.tooltips.titleFontFamily = 'Roboto';
Chart.defaults.global.tooltips.bodyFontFamily = 'Roboto';

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>

<style>
</style>